import { StackLayout } from '@progress/kendo-react-layout'
import { Dispatch, SetStateAction } from 'react'
import {
  StatusCheckActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'
import { StatusCheckCard } from './StatusCheckCard'
import { ErrorMessage } from '../../../components/parts'

interface StatusCheckResultListProps {
  changeId: Dispatch<SetStateAction<string>>
  changeArgslist: Dispatch<SetStateAction<string[]>>
  changesDemandIndex: Dispatch<SetStateAction<number>>
  changeCancelIndex: Dispatch<SetStateAction<number>>
  skip: number
  changeMessageDialogshow: Dispatch<React.SetStateAction<boolean>>
  setIsChanged: Dispatch<React.SetStateAction<boolean>>
  isChanged: boolean
  setErrorMessages: Dispatch<React.SetStateAction<ErrorMessage[]>>
}

export default function StatusCheckResultList(
  props: StatusCheckResultListProps
) {
  const statusCheckList = useAppSelector(
    (state) => state.statuscheck.statusCheckList
  )

  const dispatch = useAppDispatch()

  /** M1回答依赖状態の変更 */
  const handleReplyReqFlg = (value: number, propsIndex: number) => {
    props.setIsChanged(true)
    dispatch(
      StatusCheckActions.setReplyReqFlg({
        arrayIndex: propsIndex,
        value
      })
    )
  }

  /** M1ヒアリングシート状態の変更 */
  const handleHearingSheetFlg = (value: number, propsIndex: number) => {
    props.setIsChanged(true)
    dispatch(
      StatusCheckActions.setHearingSheetFlg({
        arrayIndex: propsIndex,
        value
      })
    )
  }

  /** M1出力対象状態の変更 */
  const handleOutputFlg = (value: number, propsIndex: number) => {
    dispatch(
      StatusCheckActions.setOutPutFlg({
        arrayIndex: propsIndex,
        value
      })
    )
  }

  return (
    <StackLayout orientation="vertical" gap={5}>
      {statusCheckList.slice(props.skip, props.skip + 20).map((item, index) => (
        <StatusCheckCard
          key={index}
          propsInfo={item}
          statusCheckListIndex={index}
          handleReplyReqFlgEvent={handleReplyReqFlg}
          handleHearingSheetFlgEvent={handleHearingSheetFlg}
          handleOutputFlgEvent={handleOutputFlg}
          {...props}
        />
      ))}
    </StackLayout>
  )
}
